import { isProduction } from '../common/utils/environment-util';

const GRAB_APP_DEEPLINK_BASE = 'grab://open';
const GRAB_APP_DEEPLINK_SCREEN_TYPE_EXPRESS = 'EXPRESS';
const GRAB_APP_DEEPLINK_SCREEN_TYPE_HELPCENTER = 'HELPCENTER';
const ONELINK_BASE = 'https://grab.onelink.me/2695613898';
const ONELINK_SOURCE_ID = 'rGCkrJ2uUI';

const getHelpCenterPage = (locale = 'en', country = 'sg') => {
  if (isProduction()) {
    return `https://help.grab.com/passenger/${locale}-${country.toLowerCase()}`;
  }
  return `https://help.stg-myteksi.com/passenger/${locale}-${country.toLowerCase()}`;
};

export const generateDeeplink = (screenType, params) => {
  const urlSearchParams = new URLSearchParams({ screenType, ...params });
  return `${GRAB_APP_DEEPLINK_BASE}?${urlSearchParams.toString()}`;
};

export const getHelpCenterOnelink = (locale, country) => {
  const deeplink = generateDeeplink(GRAB_APP_DEEPLINK_SCREEN_TYPE_HELPCENTER, {
    page: getHelpCenterPage(locale, country),
  });
  return encodeDeeplinkWithOnelink(deeplink);
};

export const encodeDeeplinkWithOnelink = (
  deeplink,
  sourceID = ONELINK_SOURCE_ID,
  campaignID = '',
) => {
  if (!deeplink) {
    return deeplink;
  }

  const urlSearchParams = new URLSearchParams();
  urlSearchParams.set('pid', sourceID);
  if (campaignID) {
    urlSearchParams.set('c', campaignID);
  }
  urlSearchParams.set('af_dp', deeplink);
  return `${ONELINK_BASE}?${urlSearchParams.toString()}`;
};

export const generateOnelinkToInTransitScreen = ({
  bookingCode = '',
  expressServiceID = '',
  triggeredFrom = '0',
}) => {
  const deeplink = generateDeeplink(GRAB_APP_DEEPLINK_SCREEN_TYPE_EXPRESS, {
    bookingCode,
    expressServiceID,
    triggeredFrom,
  });

  return encodeDeeplinkWithOnelink(deeplink);
};
